import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { BASE_URL } from '../../components/constants';
import { useToast } from '../../components/Toast';
import { fetchAllOrganizations } from '../../slice/organizationsSlice';

const CreditHistory = () => {
  const dispatch = useDispatch();
  const { organizations } = useSelector(state => state.organizations);
  const [selectedOrg, setSelectedOrg] = useState('');
  const [loading, setLoading] = useState(false);
  const [history, setHistory] = useState([]);
  const { addToast, ToastContainer } = useToast();

  useEffect(() => {
    dispatch(fetchAllOrganizations());
  }, [dispatch]);

  const loadHistory = async (orgId) => {
    if (!orgId) {
      setHistory([]);
      return;
    }
    setLoading(true);
    try {
      const res = await axios.get(`${BASE_URL}/organizations/${orgId}/credit-history`);
      setHistory(res.data?.history || []);
    } catch (e) {
      addToast('Fehler beim Laden der Historie', 'error');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadHistory(selectedOrg);
  }, [selectedOrg]);

  const getOrganizationName = (organizationId) => {
    const org = organizations.find(o => o.organization_id === organizationId);
    return org ? org.organization_name : 'Unbekannt';
  };

  return (
    <div className="mb-16 pt-5 mt-8 mx-auto px-4 sm:px-6 rounded lg:px-8">
      <ToastContainer />
      <div className="pl-32 pr-40">
        <div className="flex justify-between items-center mb-8">
          <div>
            <h1 className="text-2xl font-semibold mb-6">Gutschrift-Historie</h1>
          </div>
          <div className="w-96">
            <select
              className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-custom-yellow"
              value={selectedOrg}
              onChange={(e) => setSelectedOrg(e.target.value)}
            >
              <option value="">Organisation auswählen...</option>
              {organizations.map(org => (
                <option key={org.organization_id} value={org.organization_id}>
                  {org.organization_name}
                </option>
              ))}
            </select>
          </div>
        </div>
        {loading ? (
          <div className="flex justify-center items-center py-8">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-custom-yellow"></div>
          </div>
        ) : (
          <div className="overflow-y-auto max-h-[60vh] no-scrollbar">
            <table className="min-w-full bg-white border border-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Datum</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Abonnement</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Aufgabe</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">übertragen Läufe</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Max Läufe</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">übertragen Läufe Seiten</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Max Seiten</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Temp Läufe</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Temp Seiten</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Aktion</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {history.map(item => (
                  <tr key={item.history_id} className="hover:bg-gray-50">
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{item.created_at}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{item.subscription_name || item.subscription_id}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{item.task_name || item.task_id}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{item.previous_available_runs ?? '-'}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{item.previous_max_runs ?? '-'}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{item.previous_available_pages ?? '-'}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{item.previous_max_pages ?? '-'}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{item.temporary_credits_given ?? '-'}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{item.temporary_pages_given ?? '-'}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{item.action}</td>
                  </tr>
                ))}
                {history.length === 0 && (
                  <tr>
                    <td className="px-6 py-4 text-sm text-gray-500" colSpan="10">Keine Einträge</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default CreditHistory;
